import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import Mousetrap from 'mousetrap';
import browserHistory from '../../history';
import PageSearch from './PageSearch';

const MainSearch = () => {
  const { pageName } = useSelector(state => state.page);
  const [focused, setFocused] = useState(false);
  const [value, setValue] = useState(pageName);

  const onFocus = () => {
    setFocused(true);
  };

  const onBlur = value => {
    setFocused(false);
    setValue('');
    return value;
  };

  const onSuggestionSelected = suggestionValue => {
    setValue(suggestionValue);

    if (suggestionValue) {
      browserHistory.push(`/${suggestionValue}`);
    }
  };

  const setFocus = () => {
    window.document.querySelector('#main-search').focus();
    return false;
  };

  const getSuggestionValue = suggestion => {
    return suggestion.name;
  };

  useEffect(() => {
    Mousetrap.bind(['/'], setFocus);

    return () => {
      Mousetrap.unbind(['/']);
    };
  }, []);

  const wrapperClass = classNames('main-search', {
    'search-focused': focused,
  });

  return (
    <div className={wrapperClass}>
      <div className="search-icon">
        <i className="fas fa-search" />
      </div>
      <div className="search-input">
        <PageSearch
          controlId="main-search"
          placeholder="Search"
          useHistory
          getSuggestionValue={getSuggestionValue}
          onSuggestionSelected={onSuggestionSelected}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={v => setValue(v)}
          renderSuggestionsContainer={({ containerProps, children }) => {
            return (
              <div {...containerProps} className="suggestion-wrapper">
                {children}
              </div>
            );
          }}
          selectOnBlur={false}
          value={value}
        />
      </div>
    </div>
  );
};

export default MainSearch;
